import { Image } from "antd";
import React, { useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import { bizBaseUrl } from "services/request";

const ReaderImage = () => {
  const state = useLocation().state;
  const chapterList = state?.chapterList || [];
  const postTitle = state?.postTitle;
  const imageInex = state?.imageInex;
  const images = chapterList.map(
    (item) =>
      // item.resourceRealityUrl?.replaceAll("\\", "/").replaceAll("D:/_Resource/",  bzBaseUrl + "/images/")
      item.optImgUrl
  );

  const [currentIndex, setCurrentIndex] = useState(imageInex || 0);
  const [isHorizontal, setIsHorizontal] = useState(true); // 初始化为横向阅读模式

  const [darkMode, setDarkMode] = useState(true);
  const [multiMode, setMultiMode] = useState(true);

  const goToNextPage = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const toggleReadingMode = () => {
    setIsHorizontal((prevMode) => !prevMode); // 切换阅读模式
  };

  // 页面内容
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        // flexDirection: isHorizontal ? "column" : "row", // 根据状态设置方向
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: darkMode ? "#000" : "#fff",
      }}
    >
      <div className=" fixed top-0 w-full z-10">
        <div
          className={[
            " flex justify-between items-center gap-5 p-3.5 bg-black bg-opacity-30",
          ].join(" ")}
        >
          <AiOutlineArrowLeft
            size={22}
            color="white"
            className="min-w-6"
            onClick={() => {
              window.history.go(-1);
            }}
          />
          <div className=" grow text-center text-sm text-white font-bold text-nowrap">
            {postTitle}
          </div>
        </div>
      </div>
      {multiMode ? (
        <div className="w-full h-full flex flex-col overflow-y-auto">
          {images.map((image) => (
            <>
              <Image
                src={image}
                alt={`Page ${currentIndex + 1}`}
                style={{
                  maxHeight: isHorizontal ? "100%" : "100vh", // 横向时高度100%，纵向时高度为100vh
                  maxWidth: isHorizontal ? "100%" : "100vw", // 横向时宽度100%，纵向时宽度为100vw
                  objectFit: "contain",
                }}
                preview={false}
              />
            </>
          ))}
        </div>
      ) : (
        <>
          <Image
            src={images[currentIndex]}
            alt={`Page ${currentIndex + 1}`}
            style={{
              maxHeight: isHorizontal ? "100%" : "100vh", // 横向时高度100%，纵向时高度为100vh
              maxWidth: isHorizontal ? "100%" : "100vw", // 横向时宽度100%，纵向时宽度为100vw
              objectFit: "contain",
            }}
            preview={false}
          />
        </>
      )}
      {multiMode ? (
        <>
          <div className=" fixed bottom-2 flex justify-around items-center w-full gap-2 p-2">
            <button
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
              onClick={() => {
                setMultiMode(!multiMode);
              }}
            >
              {!multiMode ? "卷轴模式" : "鉴赏模式"}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className=" fixed bottom-2 flex justify-around items-center w-full gap-2 p-2">
            <button
              onClick={goToPreviousPage}
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
              disabled={currentIndex === 0}
            >
              上一页
            </button>
            <button
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
              onClick={() => {
                setMultiMode(!multiMode);
              }}
            >
              {!multiMode ? "卷轴模式" : "单图模式"}
            </button>
            <button
              className=" grow"
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
            >
              {currentIndex + 1 + " / " + chapterList.length}
            </button>
            <button
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
              onClick={() => {
                setDarkMode(!darkMode);
              }}
            >
              {!darkMode ? "黑夜模式" : "白天模式"}
            </button>
            <button
              onClick={goToNextPage}
              style={{
                padding: "10px 10px",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                zIndex: 1000,
              }}
              disabled={currentIndex >= chapterList.length - 1}
            >
              下一页
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ReaderImage;
